import { useEffect, useState } from 'react';

import { useHeader } from '../../../hooks';
import { THeader } from '../../../types';
import { LoginProps } from '../Header.types';
import { mapHeaderToLargeMenuRight } from '../headerAdapter';
import {
    AderirButton,
    BigHeader,
    BigHeaderContainer,
    HeaderWrapper,
    LogoContainer,
    MiniHeader,
    MiniHeaderContainer,
    MiniHeaderLink,
    MiniHeaderLinks
} from './AmigoHeader.styles';

const SCROLL_THRESHOLD = 50;

const AmigoHeader = ({ loginProps, headerData }: { loginProps: LoginProps; headerData: THeader }) => {
    const largeMenuRight = mapHeaderToLargeMenuRight(headerData);
    const loginLabel = headerData.secondaryHeaderRight?.find((item) => item.name === 'login')?.label || 'Login';

    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            setIsScrolled(scrollPosition > SCROLL_THRESHOLD);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const logoClickHandler = () => {
        window.location.reload();
    };

    return (
        <HeaderWrapper $isScrolled={isScrolled}>
            <MiniHeader $isVisible={!isScrolled}>
                <MiniHeaderContainer>
                    <MiniHeaderLinks>
                        {largeMenuRight?.map((item, index) => (
                            <MiniHeaderLink key={index} href={item.href}>
                                {item.label}
                            </MiniHeaderLink>
                        ))}
                    </MiniHeaderLinks>
                </MiniHeaderContainer>
            </MiniHeader>
            <BigHeader>
                <BigHeaderContainer>
                    <LogoContainer onClick={logoClickHandler}>
                        <svg viewBox="0 0 108 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#a)" fill="#fff">
                                <path d="M97.183 31.118c-5.965 0-10.828-4.986-10.828-11.122 0-6.127 4.853-11.123 10.828-11.123 5.974 0 10.827 4.986 10.827 11.123-.01 6.136-4.864 11.122-10.828 11.122zm0-16.192c-2.726 0-4.936 2.27-4.936 5.07 0 2.799 2.21 5.07 4.936 5.07 2.724 0 4.935-2.271 4.935-5.07 0-2.8-2.21-5.07-4.935-5.07zM13.584 30.568c-.052-.285-.103-.58-.144-.908-.041-.327-.093-.686-.144-1.077-.525.76-1.286 1.373-2.283 1.838-.998.464-2.2.697-3.599.697-1.07 0-2.057-.159-2.961-.486-.905-.328-1.687-.782-2.345-1.373a6.204 6.204 0 0 1-1.542-2.155c-.37-.845-.556-1.806-.556-2.873 0-2.113.658-3.74 1.975-4.88 1.316-1.14 3.146-1.711 5.47-1.711h5.676v-.718c0-1.099-.34-1.912-1.008-2.43-.668-.517-1.583-.781-2.735-.781-2.139 0-3.691.93-4.648 2.788L.494 14.04c1.779-3.444 4.853-5.155 9.223-5.155 2.664 0 4.843.707 6.54 2.112 1.728 1.384 2.591 3.697 2.591 6.93v7.773c0 1.099.042 2.102.124 3 .082.898.175 1.52.288 1.859h-5.676v.01zm-.412-8.883H8.854c-.936 0-1.646.222-2.14.655-.493.433-.74 1.035-.74 1.796 0 1.658 1.039 2.493 3.126 2.493 1.018 0 1.944-.328 2.797-.972.854-.623 1.275-1.817 1.275-3.591v-.38zM53.501 17.334v13.235h-5.717V18.263c0-1.352-.319-2.387-.966-3.105-.648-.718-1.512-1.077-2.612-1.077-1.152 0-2.088.39-2.797 1.161-.71.771-1.07 1.976-1.07 3.613v11.713h-5.758V18.264c0-1.352-.319-2.376-.946-3.084-.627-.708-1.491-1.056-2.591-1.056-1.152 0-2.088.38-2.818 1.14-.73.761-1.09 1.955-1.09 3.592v11.713h-5.881V9.518h5.47l.206 1.816c1.12-1.658 3.002-2.492 5.634-2.492 1.564 0 2.91.316 4.052.95 1.141.634 2.026 1.585 2.653 2.852a6.052 6.052 0 0 1 2.468-2.788c1.12-.676 2.478-1.014 4.072-1.014 2.334 0 4.195.739 5.594 2.218 1.398 1.478 2.097 3.57 2.097 6.274zM61.779 9.518v21.05h-5.882V9.518h5.882zM55.414 3.507c0-.982.34-1.816 1.008-2.492C57.09.339 57.912 0 58.869 0c.936 0 1.727.338 2.386 1.014.658.676.987 1.51.987 2.492 0 .962-.33 1.786-.987 2.472-.659.687-1.45 1.035-2.386 1.035-.956 0-1.779-.338-2.447-1.014-.669-.676-1.008-1.5-1.008-2.493zM79.075 29.988c3.609-1.807 6.097-5.62 6.097-10.014 0-1.827-.432-3.56-1.203-5.08h1.203V8.852H74.355c-5.964 0-10.828 4.996-10.828 11.133 0 4.394 2.488 8.196 6.098 10.013-3.61 1.806-6.098 5.62-6.098 10.013h5.882c0-2.799 2.21-5.08 4.935-5.08 2.725 0 4.936 2.281 4.936 5.08h5.882c.01-4.404-2.478-8.217-6.088-10.023zm-4.72-15.094c2.725 0 4.935 2.281 4.935 5.08 0 2.8-2.21 5.08-4.935 5.08-2.725 0-4.936-2.28-4.936-5.08-.01-2.799 2.21-5.08 4.936-5.08z"></path>
                            </g>
                            <defs>
                                <clipPath id="a">
                                    <path fill="#fff" d="M0 0h108v40H0z"></path>
                                </clipPath>
                            </defs>
                        </svg>
                    </LogoContainer>
                    {loginProps.isLoggedIn ? (
                        <AderirButton onClick={loginProps.onLogout} $isVisible={true}>
                            {loginProps.loggedInInitials}
                        </AderirButton>
                    ) : (
                        <AderirButton onClick={loginProps.onLogin} $isVisible={true}>
                            {loginLabel}
                        </AderirButton>
                    )}
                </BigHeaderContainer>
            </BigHeader>
        </HeaderWrapper>
    );
};

const AmigoHeaderWrapper = ({ loginProps }: { loginProps: LoginProps }) => {
    const { headerData, loading } = useHeader({ name: 'digital_amigo_header' });

    if (loading || !headerData) return null;

    return <AmigoHeader loginProps={loginProps} headerData={headerData} />;
};

export default AmigoHeaderWrapper;
